import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './Header';
import JinshiStyles from './RateSubmissions.module.css'; // You can reuse the same styles

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const ViewJinshiSubmissions = () => {
  const [submissions, setSubmissions] = useState([]);
  const [filteredSubmissions, setFilteredSubmissions] = useState([]);
  const [submissionMap, setSubmissionMap] = useState({});
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedDay, setSelectedDay] = useState('');

  useEffect(() => {
    fetchSubmissions();
  }, []);

  const fetchSubmissions = async () => {
    try {
      const response = await axios.get(`${API_URL}/submissions/public/jinshi`);

      const submissions = response.data;
      setSubmissions(submissions);
      setFilteredSubmissions(submissions);

      const map = {};
      submissions.forEach((submission) => {
        const date = new Date(submission.submitted_at);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');

        map[year] = map[year] || {};
        map[year][month] = map[year][month] || {};
        map[year][month][day] = map[year][month][day] || [];
        map[year][month][day].push(submission);
      });
      setSubmissionMap(map);
    } catch (error) {
      console.error('Error fetching submissions:', error);
    }
  };

  const filterSubmissions = (year, month, day) => {
    if (!year && !month && !day) {
      setFilteredSubmissions(submissions);
      return;
    }
    let filtered = submissions.filter((submission) => {
      const date = new Date(submission.submitted_at);
      const subYear = date.getFullYear().toString();
      const subMonth = (date.getMonth() + 1).toString().padStart(2, '0');
      const subDay = date.getDate().toString().padStart(2, '0');

      return (!year || subYear === year) &&
             (!month || subMonth === month) &&
             (!day || subDay === day);
    });
    setFilteredSubmissions(filtered);
  };

  return (
    <>
      <Header />
      <div className={JinshiStyles.pageWrapper}>
        <div className={JinshiStyles.contentContainer}>
          <h3 className={JinshiStyles.sectionTitle}>Jinshi Submissions</h3>

          {/* Filters */}
          <div style={{ marginBottom: '20px' }}>
            <label>Year: </label>
            <select
              value={selectedYear}
              onChange={(e) => {
                setSelectedYear(e.target.value);
                filterSubmissions(e.target.value, selectedMonth, selectedDay);
              }}
            >
              <option value="">All</option>
              {Object.keys(submissionMap).sort().reverse().map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>

            <label style={{ marginLeft: '15px' }}>Month: </label>
            <select
              value={selectedMonth}
              onChange={(e) => {
                setSelectedMonth(e.target.value);
                filterSubmissions(selectedYear, e.target.value, selectedDay);
              }}
            >
              <option value="">All</option>
              {selectedYear && Object.keys(submissionMap[selectedYear] || {}).sort().map((month) => (
                <option key={month} value={month}>{month}</option>
              ))}
            </select>

            <label style={{ marginLeft: '15px' }}>Date: </label>
            <select
              value={selectedDay}
              onChange={(e) => {
                setSelectedDay(e.target.value);
                filterSubmissions(selectedYear, selectedMonth, e.target.value);
              }}
            >
              <option value="">All</option>
              {selectedMonth && selectedYear && Object.keys(submissionMap[selectedYear]?.[selectedMonth] || {}).sort().map((day) => (
                <option key={day} value={day}>{day}</option>
              ))}
            </select>
            <span style={{ marginLeft: '10px', fontSize: '0.9em', color: '#555' }}>
              (Only dates with submissions are shown)
            </span>
          </div>

          {/* Submissions */}
          {filteredSubmissions.length > 0 ? (
            <div className={JinshiStyles.cardGrid}>
              {filteredSubmissions.map((submission) => (
                <div key={submission._id} className={JinshiStyles.submissionCard}>
                  <h4 className={JinshiStyles.submissionTitle}>{submission.title || 'Final Submission'}</h4>
                  <p><strong>Poem Type:</strong> {submission.poem_type || 'Unknown'}</p>
                  <p><strong>Submitted At:</strong> {new Date(submission.submitted_at).toLocaleString()}</p>
                  <p><strong>Region:</strong> {submission.region || "N/A"}</p>

                  <div className={JinshiStyles.submissionContent}>
                    {submission.submitted_content.split("\n").map((line, index) => (
                      <div key={index} className={JinshiStyles.poemLineWrapper}>
                        <span className={JinshiStyles.poemLine}>{line}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p>No Jinshi submissions found.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewJinshiSubmissions;

